export default __webpack_public_path__ + "static/media/spike-ball.079c2d9b.svg";